module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "navigate"
  }, [_c('select', {
    staticClass: "page-demo",
    on: {
      "change": _vm.onchange
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Full demo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Simple demo")])])]), _vm._v(" "), _c('div', [(_vm.viewIndex == 1) ? _c('App') : (_vm.viewIndex == 2) ? _c('Editor') : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22aa0e5a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22aa0e5a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dev/demo.vue
// module id = 213
// module chunks = 0